import React, { PropsWithChildren } from 'react'
import { concatStyles } from 'utils'

const STRIKE_CONTAINER_STYLES = 'flex py-2'
const STRIKE_BORDER_STYLES = 'h-px bg-contentareaborder my-auto flex-auto'

const STRIKE_CONTENT_STYLES = 'font-heading'
const STRIKE_CONTENT_INLINE_STYLES = { flex: '0 0 auto' }

export const Strike: React.FC<PropsWithChildren> = ({ children }) => (
  <div className={STRIKE_CONTAINER_STYLES}>
    <div className={concatStyles([STRIKE_BORDER_STYLES, 'mr-4'])} />
    <div style={STRIKE_CONTENT_INLINE_STYLES} className={STRIKE_CONTENT_STYLES}>
      {children}
    </div>
    <div className={concatStyles([STRIKE_BORDER_STYLES, 'ml-4'])} />
  </div>
)

Strike.displayName = 'Content.Strike'
